import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import NotFound from '../ul/NotFound';

const UserChart = ({ userData }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);
    console.log(userData);
    useEffect(() => {
        if (!userData || userData.length === 0) return;

        if (chartInstance.current) {
            chartInstance.current.dispose();
        }

        const chart = echarts.init(chartRef.current);
        chartInstance.current = chart;

        const userDates = userData.reduce((acc, user) => {
            const date = new Date(user.createdAt);

            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');

            const dateKey = `${day}/${month}`;

            acc[dateKey] = (acc[dateKey] || 0) + 1;
            return acc;
        }, {});


        const sortedData = Object.entries(userDates).sort((a, b) => {
            const [dayA, monthA] = a[0].split('/').map(Number);
            const [dayB, monthB] = b[0].split('/').map(Number);
            return monthA - monthB || dayA - dayB;
        });

        const option = {
            title: {
                text: 'Users Created Over Time',
                left: 'center',
                textStyle: {
                    color: '#333',
                    fontSize: 15,
                    fontWeight: 600,
                },
            },
            tooltip: {
                trigger: 'axis',
                backgroundColor: '#fff',
                borderColor: '#0d9488',
                textStyle: { color: '#333', fontSize: 12 },
                formatter: (params) => {
                    return `${params[0].name} — <b>${params[0].value}</b> users`;
                },
            },
            grid: {
                left: '10%',
                right: '5%',
                bottom: '12%',
                top: '18%',
            },
            xAxis: {
                type: 'category',
                data: sortedData.map(([date]) => date),
                axisLine: { lineStyle: { color: '#ddd' } },
                axisLabel: {
                    color: '#666',
                    fontSize: 11,
                    rotate: sortedData.length > 10 ? 45 : 0,
                },
                splitLine: { show: false },
            },
            yAxis: {
                type: 'value',
                axisLine: { show: false },
                axisLabel: { color: '#666', fontSize: 11 },
                splitLine: { lineStyle: { color: '#f0f0f0' } },
            },
            series: [
                {
                    name: 'Users Created',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 8,
                    showSymbol: true,
                    lineStyle: { color: '#0d9488', width: 2 },
                    itemStyle: { color: '#0d9488', borderColor: '#fff', borderWidth: 2 },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: 'rgba(13, 148, 136, 0.25)' },
                            { offset: 1, color: 'rgba(13, 148, 136, 0.02)' },
                        ]),
                    },
                    data: sortedData.map(([, count]) => count),
                },
            ],
        };

        chart.setOption(option);

        const handleResize = () => chartInstance.current?.resize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            chartInstance.current?.dispose();
        };
    }, [userData]);

    return (
        <div className="border border-teal-200 p-4 rounded-lg mt-4 shadow-sm">
            {!userData?.length ? (
                <div className="flex items-center justify-center min-h-[300px]">
                    <NotFound />
                </div>
            ) : (
                <div ref={chartRef} style={{ width: '100%', height: '300px' }} />
            )}
        </div>
    );
};

export default UserChart;